import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SfaSalesLeadFileUploadLineContainerModel } from "../../../../../../models/aggregates/sfa/salesLead/SfaSalesLeadFileUploadLineContainer.model";
import { ApiVisa } from "../../shared";
import { BaseApiTemplateService } from "../../shared/base-api-template-service.model";
import { Core2Config } from "../../shared/core2Config";

@Injectable({
	providedIn: "root",
})
export class SfaSalesLeadFileUploadLineService extends BaseApiTemplateService<SfaSalesLeadFileUploadLineContainerModel> {
	readonly url =
		Core2Config.TENANT_DOMAIN_URL_PREFIX +
		Core2Config.SFA_MODULE_PREFIX +
		"sales-lead-file-upload/lines";

	constructor(http: HttpClient) {
		super();
		this.apiUrl =
			Core2Config.DOMAIN_URL +
			Core2Config.TENANT_DOMAIN_URL_PREFIX +
			Core2Config.SFA_MODULE_PREFIX +
			"sales-lead-file-upload/lines";
		this.endpoint_path =
			Core2Config.TENANT_DOMAIN_URL_PREFIX +
			Core2Config.SFA_MODULE_PREFIX +
			"sales-lead-file-upload/lines";
		this.httpClient = http;
	}
}
